module.exports = __webpack_public_path__ + "674211ea0c24c09211c5185e951c8b4a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/pgim_funds_prudential_.png
// module id = 1489
// module chunks = 0